namespace TabAurous.Inventory {
    export interface SKURepricingItemsRow {
        TransactionId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        RoutingId?: number;
        GroupId?: number;
        ItemTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        HasBom?: boolean;
        AttributeId?: number;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        HSN?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        GrossAmount?: number;
        Purity?: number;
        PureWeight?: number;
        Hallmark?: number;
        CostMethodId?: number;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        RefTransItemId?: number;
        RefTransId?: number;
        DesignId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        StockAllocation?: boolean;
        DeliveryDate?: string;
        CompanyId?: number;
        FancyCharges?: number;
        OtherCharges?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        DiscountPer?: number;
        Lab?: string;
        MFAmount?: number;
        MF?: number;
        BOMDetails?: SKURepricingBOMRow[];
        LaborDetails?: SKURepricingLaborRow[];
        __id?: string;
        KaratId?: number;
        ProductSizeId?: number;
        MetalId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        ExportPieces?: number;
        TaxCode?: string;
        DesignCode?: string;
        Attribute?: string;
        HUID?: string;
        StampId?: number;
        StoneRate?: number;
        OtherRate?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        CalcUnitId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
    }

    export namespace SKURepricingItemsRow {
        export const idProperty = 'TransactionId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Inventory.SKURepricingItems';
        export const deletePermission = 'Inventory:SKURepricing:Delete';
        export const insertPermission = 'Inventory:SKURepricing:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:SKURepricing:Edit';

        export declare const enum Fields {
            TransactionId = "TransactionId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            RoutingId = "RoutingId",
            GroupId = "GroupId",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            HasBom = "HasBom",
            AttributeId = "AttributeId",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            HSN = "HSN",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            Purity = "Purity",
            PureWeight = "PureWeight",
            Hallmark = "Hallmark",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            DesignId = "DesignId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            StockAllocation = "StockAllocation",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            DiscountPer = "DiscountPer",
            Lab = "Lab",
            MFAmount = "MFAmount",
            MF = "MF",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            __id = "__id",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            MetalId = "MetalId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            ExportPieces = "ExportPieces",
            TaxCode = "TaxCode",
            DesignCode = "DesignCode",
            Attribute = "Attribute",
            HUID = "HUID",
            StampId = "StampId",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            CalcUnitId = "CalcUnitId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth"
        }
    }
}
